var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMiniBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 346,
    viewBox: "0 0 346 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.401 247.46H162.071C156.747 247.46 152.431 251.776 152.431 257.1V335.85C152.431 341.174 156.747 345.49 162.071 345.49H183.401C188.725 345.49 193.041 341.174 193.041 335.85V257.1C193.041 251.776 188.725 247.46 183.401 247.46Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.401 0H162.071C156.747 0 152.431 4.31597 152.431 9.64V88.39C152.431 93.714 156.747 98.03 162.071 98.03H183.401C188.725 98.03 193.041 93.714 193.041 88.39V9.64C193.041 4.31597 188.725 0 183.401 0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.39 152.44H9.64C4.31597 152.44 0 156.756 0 162.08V183.41C0 188.734 4.31597 193.05 9.64 193.05H88.39C93.714 193.05 98.03 188.734 98.03 183.41V162.08C98.03 156.756 93.714 152.44 88.39 152.44Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.84 152.44H257.09C251.766 152.44 247.45 156.756 247.45 162.08V183.41C247.45 188.734 251.766 193.05 257.09 193.05H335.84C341.164 193.05 345.48 188.734 345.48 183.41V162.08C345.48 156.756 341.164 152.44 335.84 152.44Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0505 287.35L58.1305 302.43C61.8905 306.19 68.0005 306.19 71.7605 302.43L127.44 246.75C131.2 242.99 131.2 236.88 127.44 233.12L112.36 218.04C108.6 214.28 102.49 214.28 98.7305 218.04L43.0505 273.72C39.2905 277.48 39.2905 283.59 43.0505 287.35Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.706 43.0567L218.022 98.7414C214.257 102.506 214.257 108.61 218.022 112.374L233.104 127.457C236.869 131.222 242.973 131.222 246.737 127.457L302.422 71.7723C306.186 68.0077 306.186 61.9039 302.422 58.1393L287.339 43.0567C283.575 39.292 277.471 39.292 273.706 43.0567Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiniBlack);
export default __webpack_public_path__ + "static/media/logo_mini_black.fc72817ef0a6b9e4a4ad90c1d32d7757.svg";
export { ForwardRef as ReactComponent };